module.exports = __webpack_public_path__ + "static/media/MVNZ_web_1.02c158a9.jpg";